// panel-wrapper.component.ts
import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-default-panel',
  template: `
    <div class="custom-formly-field-wrapper">
        @if(props.label){
            <strong for="field.id">{{props.label}}<span *ngIf="props.required">*</span></strong>
        }
        <ng-container #fieldComponent></ng-container>

        <div *ngIf="showError" class="col-sm-3 invalid-feedback d-block">
          <formly-validation-message [field]="field"></formly-validation-message>
        </div>
    </div>
  `,
})
export class PanelDefaultFieldWrapper extends FieldWrapper {}
